import { job } from '@stereoagency/sanity-schema';

export const jobsQuery = job.schema.builder
  .pick(['_id', 'datetime', 'slug', 'title', 'description', 'location', 'pdf'])
  .map((resolver) => ({
    taxonomies: resolver.taxonomies.resolveIn(['slug', 'name']).use()
  }))
  .use();
